import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class PathStore {
  path: any[] = [];

  constructor() {
    makeObservable(this, {
      path: observable,
      setPath: action,
      clearPath: action,
    });
    makePersistable(this, {
      name: 'PathStore',
      properties: ['path'],
      storage: window.localStorage,
    });
  }

  setPath(itemName: any[]) {
    this.path = itemName;
  }

  clearPath() {
    this.path = [];
  }
}
export default PathStore;
